import React from 'react'
import { Route, Routes } from "react-router-dom"
import TransshipmentCreateScreen from "screens/App/CRM/Transshipment/TransshipmentCreateScreen"
import TransshipmentDetailScreen from "screens/App/CRM/Transshipment/TransshipmentDetailScreen"
import TransshipmentEditScreen from "screens/App/CRM/Transshipment/TransshipmentEditScreen"
import TransshipmentListScreen from "screens/App/CRM/Transshipment/TransshipmentListScreen"
import NotFoundScreen from "screens/NotFoundScreen"

const TranshipmentRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<TransshipmentCreateScreen />} />

            <Route path="list" element={<TransshipmentListScreen />} />

            <Route path=":id/detail" element={<TransshipmentDetailScreen />} />

            <Route path=":id/edit" element={<TransshipmentEditScreen />} />

            <Route path="*" element={<NotFoundScreen />} />

        </Routes>
    )
}

export default TranshipmentRouter